module.exports = __webpack_public_path__ + "img/starname-small.6ec0ffb8.svg";